/*****************************************************************
 * VIEWPORT LAYOUT
 * Single source of truth for splitting the canvas across viewports.
 * Desktop: horizontal split (side-by-side).
 * Portrait mobile: vertical split (top/bottom).
 * ***************************************************************/

export const isVerticalSplit = (viewportCount, isPortrait) =>
    isPortrait && viewportCount > 1

export const computeViewportBoxes = (canvasWidth, canvasHeight, viewportCount, isPortrait) => {
    const vertical = isVerticalSplit(viewportCount, isPortrait)
    const width = vertical ? canvasWidth : Math.floor(canvasWidth / viewportCount)
    const height = vertical ? Math.floor(canvasHeight / viewportCount) : canvasHeight

    return Array.from({ length: viewportCount }, (_, i) => ({
        x: vertical ? 0 : Math.floor(width * i),
        y: vertical ? Math.floor(height * (viewportCount - 1 - i)) : 0,
        width,
        height
    }))
}
